import React from 'react';
import { useNotify } from './NotificationContext';
import './NotificationContext.css';

const NotificationDisplay = () => {
  const { message, visible } = useNotify();

  if (!visible) return null;

  return <div className="notify-popup">{message}</div>;
};

export default NotificationDisplay;
